import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, GuardResult, Router, RouterStateSnapshot } from "@angular/router";
import { ScanCode, UserBase } from "@core/models";
import { AuthService } from "@core/services/auth.service";
import { UserService } from "@core/services/user.service";
import { Observable, of } from "rxjs";

@Injectable()
export class AuthGuard implements CanActivate {

  private readonly authService = inject(AuthService);
  private readonly userService = inject(UserService);
  private readonly router = inject(Router);

  updateMainUser(i: string, c: string): void {
    const dto: UserBase & ScanCode = {
      ...this.userService.user,
      scan3d_code: c,
      scan3d_id: i,
    }

    this.userService.updateUser(dto).pipe().subscribe({
      next: () => {
        this.router.navigate(["/home"]);
      }
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<GuardResult> {
    if (this.authService.getToken() && this.userService.user) {
      const { c, i } = route.queryParams;
      if (!!c && !!i) {
        if (this.userService.user.guests?.length > 0) {
          this.router.navigate(["/link-guests"], { queryParams: { ...route.queryParams }});
        } else {
          this.updateMainUser(i, c);
        }
      } else {
        this.router.navigate(["/home"]);
      }
      return of(false);
    }

    return of(true);
  }
}
